import { NavLink, Link, useLocation } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';
import { CraftContext } from '../../../context/crafts/CraftContext';
import { ChatContext } from '../../../context/chat/ChatContext';
import {
  ChevronDown,
  ArrowRight,
  Layers,
  Users,
  HelpCircle,
} from 'lucide-react';

export default function NavbarNavigation({ loggedIn, userDetail }) {
  const { categorizedCrafts, loadingCategorizedCrafts } =
    useContext(CraftContext);
  const { unreadMsgCount } = useContext(ChatContext);
  const [isCraftsOpen, setIsCraftsOpen] = useState(false);
  const [showScrollInfo, setShowScrollInfo] = useState(true);
  const location = useLocation();

  console.log(categorizedCrafts, 'categorizedCrafts');

  // Close menu when location changes (on navigation)
  useEffect(() => {
    setIsCraftsOpen(false);
  }, [location]);

  // Reset scroll info when menu opens/closes
  useEffect(() => {
    if (!isCraftsOpen) {
       setShowScrollInfo(true);
    }
  }, [isCraftsOpen]);

  const handleScroll = (e) => {
    if (e.target.scrollTop > 50) {
      setShowScrollInfo(false);
    } else {
      setShowScrollInfo(true);
    }
  };

  return (
    <div className="hidden lg:flex items-center gap-4 xl:gap-8 text-sm xl:text-base">
      {/* explore navigation */}
      {loggedIn && (
        <NavLink
          to="/feed"
          className={({ isActive }) =>
            isActive
              ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
              : 'text-dim-700'
          }
        >
          Explore
        </NavLink>
      )}

      {/* discover navigation */}
      {!loggedIn && (
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive
              ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
              : 'text-dim-700'
          }
        >
          Discover
        </NavLink>
      )}

      {/* artisans navigation */}
      {(!loggedIn || userDetail?.active_role === 'user') && (
        <NavLink
          to="/artisans"
          className={({ isActive }) =>
            isActive
              ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
              : 'text-dim-700'
          }
        >
          Hire Artisans
        </NavLink>
      )}

      {/* categories navigation - MEGAMINU */}
      <div
        className="py-6 -my-6 flex items-center h-full relative"
        onMouseEnter={() => setIsCraftsOpen(true)}
        onMouseLeave={() => setIsCraftsOpen(false)}
      >
        <NavLink
          to="/categories"
          className={({ isActive }) =>
            `flex items-center gap-1 transition-colors ${
              isActive
                ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
                : isCraftsOpen
                  ? 'text-rose-600 font-semibold'
                  : 'text-dim-700'
            } hover:text-rose-600`
          }
        >
          Crafts
          <ChevronDown
            className={`w-4 h-4 transition-transform ${isCraftsOpen ? 'rotate-180' : ''}`}
          />
        </NavLink>

        {/* Refined Floating Mega Menu Dropdown */}
        <div
          className={`fixed top-16 sm:top-20 left-4 right-4 max-w-[1024px] mx-auto bg-white rounded-[2rem] border border-gray-100 shadow-[0_40px_80px_-15px_rgba(0,0,0,0.12)] transition-all duration-300 z-50 cursor-default flex flex-col overflow-hidden ${isCraftsOpen ? 'opacity-100 visible translate-y-4' : 'opacity-0 invisible translate-y-6'}`}
        >
          <div 
            onScroll={handleScroll}
            className="flex-1 px-10 py-10 w-full max-h-[70vh] overflow-y-auto custom-scrollbar"
          >
            <div className="grid grid-cols-4 gap-x-10 gap-y-12">
              {loadingCategorizedCrafts ? (
                <div className="col-span-4 py-20 flex flex-col items-center justify-center gap-4">
                  <div className="w-10 h-10 border-4 border-rose-500 border-t-transparent rounded-full animate-spin" />
                  <p className="text-gray-400 text-sm font-bold uppercase tracking-[0.3em]">
                    Curating excellence...
                  </p>
                </div>
              ) : categorizedCrafts?.length > 0 ? (
                categorizedCrafts
                  .filter((cat) => cat.crafts && cat.crafts.length > 0)
                  .slice(0, 7)
                  .map((category) => (
                    <div
                      key={category.category_name}
                      className="flex flex-col gap-4"
                    >
                      <h4 className="text-gray-900 font-bold text-[15px] flex items-center gap-2 px-1">
                        {category.category_name}
                      </h4>
                      <div className="flex flex-col gap-1 pt-2">
                        {category.crafts.slice(0, 4).map((craft) => (
                          <Link
                            key={craft.id}
                            to={`/craft/${craft.id}`}
                            className="group/link flex items-center gap-3 p-2.5 -mx-2.5 rounded-xl hover:bg-white hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-transparent hover:border-gray-100 transition-all duration-300"
                          >
                            <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center shrink-0 border border-gray-100 overflow-hidden relative">
                               <div className="absolute inset-0 bg-black/0 group-hover/link:bg-black/5 transition-colors z-10 duration-300" />
                               <img 
                                  src={craft.image || `https://placehold.co/80x80/f8fafc/94a3b8?text=${(craft.name || 'C').charAt(0).toUpperCase()}`}
                                  alt=""
                                  className="w-full h-full object-cover group-hover/link:scale-110 transition-transform duration-500"
                                  onError={(e) => { e.target.src = `https://placehold.co/80x80/f8fafc/94a3b8?text=${(craft.name || 'C').charAt(0).toUpperCase()}`; }}
                               />
                            </div>
                            <div className="flex flex-col flex-1 overflow-hidden">
                              <span className="text-gray-800 font-bold text-[13px] group-hover/link:text-rose-600 transition-colors truncate">
                                {craft.name}
                              </span>
                              <span className="text-gray-400 text-[11px] font-semibold mt-0.5 flex items-center gap-1 group-hover/link:text-gray-500 transition-colors">
                                Explore directory 
                                <ArrowRight className="w-3 h-3 opacity-0 -translate-x-2 group-hover/link:opacity-100 group-hover/link:translate-x-0 transition-all duration-300 text-rose-500" />
                              </span>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))
              ) : null}
              {/* 8th tile — Quick Links */}
              {!loadingCategorizedCrafts && categorizedCrafts?.length > 0 && (
                <div className="flex flex-col gap-4">
                  <h4 className="text-gray-900 font-bold text-[15px] flex items-center gap-2 px-1">
                    Quick Links
                  </h4>
                  <div className="flex flex-col gap-3 pl-3 border-l-2 border-rose-50">
                    <Link
                      to="/categories"
                      className="flex items-center gap-2 text-sm font-semibold text-rose-600 bg-rose-50 hover:bg-rose-100 rounded-xl px-3 py-2.5 transition-all group"
                    >
                      <Layers className="w-4 h-4 shrink-0" />
                      <span className="leading-tight">
                        Explore All Categories
                      </span>
                      <ArrowRight className="w-3.5 h-3.5 ml-auto opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
                    </Link>
                    <Link
                      to="/artisans"
                      className="flex items-center gap-2 text-sm font-semibold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 rounded-xl px-3 py-2.5 transition-all group"
                    >
                      <Users className="w-4 h-4 shrink-0" />
                      <span className="leading-tight">Expert Artisans</span>
                      <ArrowRight className="w-3.5 h-3.5 ml-auto opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
                    </Link>
                    <Link
                      to="/how-it-works"
                      className="flex items-center gap-2 text-sm font-semibold text-emerald-600 bg-emerald-50 hover:bg-emerald-100 rounded-xl px-3 py-2.5 transition-all group"
                    >
                      <HelpCircle className="w-4 h-4 shrink-0" />
                      <span className="leading-tight">How to Hire</span>
                      <ArrowRight className="w-3.5 h-3.5 ml-auto opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
                    </Link>
                  </div>
                </div>
              )}
              {/* Empty state */}
              {!loadingCategorizedCrafts &&
                (!categorizedCrafts || categorizedCrafts.length === 0) && (
                  <div className="col-span-4 text-center py-20">
                    <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-6">
                      <Layers className="text-gray-300 w-10 h-10" />
                    </div>
                    <p className="text-gray-400 font-semibold italic text-lg">
                      Our library is currently being updated. Come back soon!
                    </p>
                  </div>
                )}
            </div>
          </div>
          
          {/* Scroll discovery indicator overlay */}
          <div className={`absolute bottom-16 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none z-10 transition-opacity duration-500 ${showScrollInfo ? 'opacity-100' : 'opacity-0'}`} />
          
          <div className={`absolute bottom-20 left-1/2 -translate-x-1/2 z-20 pointer-events-none flex flex-col items-center gap-1 transition-all duration-500 ${showScrollInfo ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
             <div className="bg-rose-600/90 backdrop-blur-md text-white text-[9px] font-black uppercase tracking-[0.2em] px-4 py-1.5 rounded-full shadow-xl flex items-center gap-2">
                <span>Scroll to discover more</span>
                <ChevronDown size={10} className="animate-bounce" />
             </div>
          </div>

          {/* Bottom Banner */}
          <div className="bg-gray-50/80 py-4 px-10 border-t border-gray-50 shrink-0 relative z-20">
            <div className="flex justify-between items-center text-[10px] font-bold text-gray-400 uppercase tracking-widest">
              <span>Handpreuners Directory © 2026</span>
            </div>
          </div>
        </div>
      </div>

      {/* messages navigation */}
      {loggedIn && (
        <NavLink
          to="/messages"
          className={({ isActive }) =>
            `flex items-center gap-1 ${
              isActive
                ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
                : 'text-dim-700'
            }`
          }
        >
          Messages
          {unreadMsgCount > 0 && (
            <span className="bg-rose-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] h-[18px] flex items-center justify-center -translate-y-2 translate-x-1">
              {unreadMsgCount > 99 ? '99+' : unreadMsgCount}
            </span>
          )}
        </NavLink>
      )}

      {/* how-it-works navigation */}
      {!loggedIn && (
        <NavLink
          to="/how-it-works"
          className={({ isActive }) =>
            isActive
              ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
              : 'text-dim-700'
          }
        >
          Handpreneur Flow
        </NavLink>
      )}

      {loggedIn && (
        <NavLink
          to={
            userDetail?.active_role === 'artisan'
              ? '/artisan/dashboard'
              : '/user/dashboard'
          }
          className={({ isActive }) =>
            isActive
              ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
              : 'text-gray-700 hover:text-gray-900'
          }
        >
          Dashboard
        </NavLink>
      )}

      {!loggedIn && (
        <NavLink
          to="/support"
          className={({ isActive }) =>
            isActive
              ? 'text-rose-600 font-semibold border-b-2 border-rose-600'
              : 'text-gray-700 hover:text-gray-900'
          }
        >
          Support
        </NavLink>
      )}
    </div>
  );
}
